export default __webpack_public_path__ + "static/media/video-sdg-6.8d21d51e.mp4";